/**
 * Money going out (t1164): payments to vendors, staff and freelancers, and
 * operating expenses like rent or printing. Separate from `VENDOR_PAYMENT_STATUSES`
 * in purchasing.ts, which is the per-cost-line paid flag a payment here can set.
 */
export const OUTGOING_PAYMENT_KINDS = ['vendor', 'staff', 'payee', 'expense'];
/** `unpaid` is a bill that is due (e.g. this month's rent); `void` keeps history instead of deleting. */
export const OUTGOING_PAYMENT_STATUSES = ['unpaid', 'paid', 'void'];
/** How the money moved at the bank — recorded here, never sent from the app. */
export const OUTGOING_PAYMENT_METHODS = [
    'ach',
    'echeck',
    'zelle',
    'check',
    'cash',
    'card',
    'other',
    /** Stock taken from inventory for the office (t1223) — no money moved. Set only by the system. */
    'stock',
];
/** What a person may pick; `stock` is written only when inventory is used in the office. */
export const MANUAL_PAYMENT_METHODS = OUTGOING_PAYMENT_METHODS.filter((m) => m !== 'stock');
export const OUTGOING_PAYMENT_METHOD_LABELS = {
    ach: 'ACH',
    echeck: 'eCheck',
    zelle: 'Zelle',
    check: 'Check',
    cash: 'Cash',
    card: 'Card',
    other: 'Other',
    stock: 'From stock',
};
export const OUTGOING_PAYMENT_KIND_LABELS = {
    vendor: 'Vendor',
    staff: 'Staff',
    payee: 'Freelancer',
    expense: 'Expense',
};
//# sourceMappingURL=expenses.js.map